@if ((!sidebar && !entityPicked) || (sidebar && entityPicked && recentActivity.length > 1)) {
  <article
    [ngClass]="sidebar ? 'sidebar' : 'left-panel'"
    class="recent-activity"
    >
    <div class="box-no-files-text">
      @if (!sidebar) {
        <h2 class="placeholder-text">
          {{ getStartedLabel }}
        </h2>
      }
      @if (loggedIn && recentActivity.length > 0) {
        <div id="recent-container" @transitionRecentActivity>
          @if (!sidebar) {
            <h4 id="recent-title">Your recent activity</h4>
          }
          @if (sidebar) {
            <h2 class="heading-underline">Your recent activity</h2>
          }
          <ul class="recent-activity">
            @for (entity of recentActivity; track entity) {
              <li
                (click)="navigateToEntity(entity)"
                (keydown.enter)="navigateToEntity(entity)"
                (keydown.space)="navigateToEntity(entity)"
                tabindex="0"
                >
                <section id="profile-pic" class="small">
                  <div class="profile-pic-container">
                    @if (entity.profilePic) {
                      <img src="{{ entity.profilePic }}" (error)="imageFailed(entity)" />
                    }
                    @if (!entity.profilePic) {
                      <div class="preview-initials">
                        {{ entity.name | GetInitials }}
                      </div>
                    }
                  </div>
                </section>
                <div class="profile-name">
                  <span>{{ entity.name }}</span>
                  @if (entity.companyName) {
                    <span> {{ entity.companyName }}</span>
                  }
                </div>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </article>
}
